import { render, staticRenderFns } from "./mobile-editor.vue?vue&type=template&id=4e72f082&scoped=true"
import script from "./mobile-editor.vue?vue&type=script&lang=js"
export * from "./mobile-editor.vue?vue&type=script&lang=js"
import style0 from "./mobile-editor.vue?vue&type=style&index=0&id=4e72f082&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e72f082",
  null
  
)

export default component.exports